function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.05,6.83c-1.57.9-2.34,2.78-2.26,5.35A15.56,15.56,0,0,0,10,19.07a15.39,15.39,0,0,0,4.79,5.32c2.08,1.39,4.15,1.63,5.76.75h0l1.08-.68A1.07,1.07,0,0,0,22,23.07L19.9,19.45a1.07,1.07,0,0,0-1.39-.37l-1.13.58c-.49.29-2.46.23-4-2.58s-.76-4.49-.19-4.79l1.15-.58a1.06,1.06,0,0,0,.37-1.39l-2-3.59a1.05,1.05,0,0,0-1.39-.37C11.21,6.18,10.05,6.83,10.05,6.83Z",
    style: {
      fill: "#7e7e7e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialDesk);
export default __webpack_public_path__ + "static/media/dial-desk.5c72b269.svg";
export { ForwardRef as ReactComponent };